import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconFileText} from '@tabler/icons-react';
import React, {useState} from 'react';
import {Button} from 'src/design/atoms/Button';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {useGenerateInspectionFormPdfMutation} from 'src/redux/queries/inspection';
import {useDocumentDownload} from 'src/shared/hooks/useDocumentDownload';
import {ComplianceLetterDialog} from './ComplianceLetterDialog';

export interface InspectionDocumentsCardProps {
  inspectionId: number;
}

/**
 * Documents section for a completed inspection: the form PDF downloads inline,
 * the compliance letter opens an edit-then-generate dialog.
 */
export const InspectionDocumentsCard: React.FC<InspectionDocumentsCardProps> = ({
  inspectionId,
}) => {
  const {download} = useDocumentDownload();
  const [letterOpened, setLetterOpened] = useState(false);
  const [generateForm, {isLoading: isGeneratingForm}] =
    useGenerateInspectionFormPdfMutation();

  const handleDownloadForm = () =>
    download(
      timeZone => generateForm({id: inspectionId, timeZone}).unwrap(),
      `inspection-form-${inspectionId}.pdf`
    );

  return (
    <>
      <SectionCard title="Inspection documents" icon={<IconFileText size={16} />}>
        <Stack gap="sm" p="md">
          <Text size="sm" c="dimmed">
            Generate documents on demand from this inspection&apos;s results.
          </Text>
          <Group gap="sm">
            <Button
              variant="default"
              onClick={handleDownloadForm}
              loading={isGeneratingForm}>
              Inspection form (PDF)
            </Button>
            <Button variant="default" onClick={() => setLetterOpened(true)}>
              Letter of compliance (PDF)
            </Button>
          </Group>
        </Stack>
      </SectionCard>

      <ComplianceLetterDialog
        inspectionId={inspectionId}
        opened={letterOpened}
        onClose={() => setLetterOpened(false)}
      />
    </>
  );
};
